import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";
import assignmentActions from "../../state/assignment/actions";
import Modal from "../../blocks/Modal";
import Button from "../../blocks/Button";
import Radio from "../../blocks/Radio";
import { LanguageCheckbox } from "../../blocks/Checkbox";
import manifestHelper from "../../../../services/assignment/manifest";
import icons from "../../blocks/Table/Tracking/icons";
import { useTranslation } from "react-i18next";

export default function EditModalWrapper(props) {
  if (!props.editModalData) return null;
  return <EditModal {...props} />;
}

function EditModal(props) {
  const { editModalData, type } = props;
  const { first_name, last_name, studentId, manifest } = editModalData;
  const [languages, setLanguages] = useState(manifestHelper.getLocales(manifest));
  const [page, setPage] = useState(1);
  const [workingManifest, setWorkingManifest] = useState(type === "BENCHMARK" ? manifest : [{"activityType": "assessment","locale": "EN_US","sequence": "CONTINUE"}]);
  const students = useSelector((state) => state.reports.assignment.students);

  const {t} = useTranslation("tracking_report");

  const dispatch = useDispatch();
  const setAssignmentState = (state) =>
    dispatch(assignmentActions.setState(state));

  const studentName = `${first_name} ${last_name}`;

  return (
    <Modal isOpen={true} renderCloseIcon={false} onClose={props.onClose}>
      <div className="edit-modal-body">
        <div className="modal-title">
          {t("assessment_configuration", { studentName })}
        </div>
        <div style={{ marginLeft: 30 }}>{renderContent()}</div>
      </div>
    </Modal>
  );

  function renderContent() {
    if (page === 1) {
      const bilingual = languages.length === 2;
      return (
        <div>
          <div className="subtitle">{t("SELECT LANGUAGES")}</div>
          <div className='checkbox-with-flag'>
            <LanguageCheckbox
              label={t("English")}
              checked={languages.includes("EN_US")}
              onClick={() => toggleLanguage("EN_US")}
            />
            <img src={icons.english} />
          </div>
            <div className='checkbox-with-flag'>
            <LanguageCheckbox
              label={t("Spanish")}
              checked={languages.includes("ES_MX")}
              onClick={() => toggleLanguage("ES_MX")}
            />
            <img src={icons.spanish} />
          </div>
          <div className="controls">
            {renderCancel()}
            {bilingual ? (
              <Button onClick={() => {
                let manifestToUse = type === "BENCHMARK" ? manifest : workingManifest;
                const hasBreaks = manifestHelper.numBreaks(manifestToUse) > 0;
                const newManifest = manifestHelper.transformManifest(manifestToUse,languages,hasBreaks);

                setWorkingManifest(newManifest);
                setPage(2)}}>Next</Button>
            ) : (
              <Button
                disabled={!languages[0]}
                onClick={() => {
                  let manifestToUse = type === "BENCHMARK" ? manifest : workingManifest;
                  const hasBreaks = manifestHelper.numBreaks(manifestToUse) > 0;
                  const newManifest = manifestHelper.transformManifest(manifestToUse,languages,hasBreaks);
                  updateManifest(newManifest);
                }}
              >
                {t("common:Confirm")}
              </Button>
            )}
          </div>
        </div>
      );
    }

    if (page === 2) {
      return (
        <div>
          <div className="subtitle">NUMBER OF TESTS</div>
          <Radio
            label="2 Tests, Spanish then English"
            checked={manifestHelper.numBreaks(workingManifest) === 1 && workingManifest[0].locale === "ES_MX"}
            onClick={() => {
              setWorkingManifest(manifestHelper.transformManifest(workingManifest,["ES_MX","EN_US"],true));
            }}
          />
          <Radio
            label="2 Tests, English then Spanish"
            checked={manifestHelper.numBreaks(workingManifest) === 1 && workingManifest[0].locale === "EN_US"}
            onClick={() => {
              setWorkingManifest(manifestHelper.transformManifest(workingManifest,["EN_US","ES_MX"],true));
            }}
          />
          <Radio
            label="1 Test, Spanish then English"
            checked={manifestHelper.numBreaks(workingManifest) === 0 && workingManifest[0].locale === "ES_MX"}
            onClick={() => {
              setWorkingManifest(manifestHelper.transformManifest(workingManifest,["ES_MX","EN_US"],false));
            }}
          />
          <Radio
            label="1 Test, English then Spanish"
            checked={manifestHelper.numBreaks(workingManifest) === 0 && workingManifest[0].locale === "EN_US"}
            onClick={() => {
              setWorkingManifest(manifestHelper.transformManifest(workingManifest,["EN_US","ES_MX"],false));
            }}
          />
          <div className="controls">
          {renderCancel()}
            <Button
              onClick={() => {
                updateManifest(workingManifest);
              }}
            >
              {t("common:Confirm")}
            </Button>

          </div>
        </div>
      );
    }
  }

  function renderCancel() {
    return <Button type='secondary' style={{marginRight: 12, width: 'auto'}} onClick={props.onClose}>{t("common:Cancel")}</Button>
  }

  function toggleLanguage(locale) {
    const update = Array.from(languages);
    const i = update.indexOf(locale);
    if (i >= 0) update.splice(i, 1);
    else update.push(locale);
    setLanguages(update);
  }

  function updateManifest(manifest) {
    // find index of current student within redux state
    const i = students.map((s) => s.studentId).indexOf(studentId);
    // update manifest for student at that index
    const update = cloneDeep(students);
    update[i].manifest = manifest;
    update[i].edited = true;
    setAssignmentState({ students: update});
    props.onClose();
  }
}
